import { alpha } from '@mui/material';

export const getPopoverPaperStyle = (theme) => ({
  width: 320,
  mt: 1,
  borderRadius: "0.75rem",
  overflow: "hidden",
  border: `1px solid ${theme.palette.divider}`,
});

export const getPopoverHeaderBoxStyle = (theme) => ({
  px: 2,
  py: 1.5,
  background: theme.palette.mode === 'dark'
    ? `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.15)}, ${alpha(theme.palette.primary.dark, 0.1)})`
    : `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.15)}, ${alpha(theme.palette.primary.main, 0.08)})`,
  borderBottom: `1px solid ${theme.palette.divider}`,
});

export const getPopoverHeaderLabelStyle = () => ({
  color: 'text.secondary', 
  fontWeight: 500, 
  fontSize: '0.7rem', 
  letterSpacing: 0.3
});

export const getPopoverHeaderValueStyle = () => ({
  fontWeight: 700, 
  fontSize: '1.25rem', 
  color: 'text.primary', 
  lineHeight: 1.3
});

export const getPopoverActionBoxStyle = (theme) => ({
  px: 2, 
  py: 1.25, 
  display: 'flex', 
  alignItems: 'center', 
  gap: 1, 
  borderBottom: `1px solid ${theme.palette.divider}`
});

export const getWithdrawButtonStyle = (theme) => ({
  flex: 1,
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.75rem',
  borderRadius: 1.5,
  py: 0.6,
  boxShadow: `0 2px 8px ${theme.palette.success.main}20`,
  background: `linear-gradient(45deg, ${theme.palette.success.main}, ${theme.palette.success.dark})`,
  '&:hover': {
    background: `linear-gradient(45deg, ${theme.palette.success.dark}, ${theme.palette.success.main})`,
    boxShadow: `0 4px 12px ${theme.palette.success.main}30`,
  },
});

export const getAddFundsButtonStyle = (theme) => ({
  flex: 1,
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.75rem',
  borderRadius: 1.5,
  py: 0.6,
  background: theme.palette.primary.main,
  '&:hover': {
    background: theme.palette.primary.dark,
  },
});

export const getRefreshIconButtonStyle = (theme) => ({
  color: 'text.secondary',
  '&:hover': { 
    color: 'primary.main', 
    backgroundColor: alpha(theme.palette.primary.main, 0.08) 
  },
});

export const getOverviewTitleBoxStyle = () => ({
  px: 2, 
  pt: 1.25, 
  pb: 0.5
});

export const getOverviewTitleStyle = () => ({
  color: 'text.secondary', 
  fontWeight: 600, 
  fontSize: '0.7rem', 
  letterSpacing: 0.5, 
  textTransform: 'uppercase'
});

export const getOverviewRowBoxStyle = () => ({
  display: 'flex', 
  justifyContent: 'space-between', 
  alignItems: 'center', 
  px: 2, 
  py: 0.75
});

export const getOverviewRowLabelStyle = () => ({
  fontSize: '0.75rem', 
  color: 'text.secondary', 
  fontWeight: 500
});

export const getOverviewRowValueStyle = (theme, item) => ({
  fontSize: '0.75rem',
  fontWeight: 600,
  color: item.isPnl
    ? (item.positive ? theme.palette.success.main : theme.palette.error.main)
    : parseFloat(item.value?.toString().replace(/[^\d.-]/g, '')) < 0
      ? theme.palette.error.main
      : 'text.primary',
});

export const getMobileBottomSheetPaperStyle = () => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  m: 0,
  borderRadius: '1rem 1rem 0 0',
  maxHeight: '80vh',
  width: '100%',
  maxWidth: '100%',
});

export const getMobileBottomSheetHeaderStyle = (theme) => ({
  px: 2.5,
  py: 2,
  background: theme.palette.mode === 'dark'
    ? `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.15)}, ${alpha(theme.palette.primary.dark, 0.1)})`
    : `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.15)}, ${alpha(theme.palette.primary.main, 0.08)})`,
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const getMobileBottomSheetActionBoxStyle = (theme) => ({
  px: 2.5,
  py: 1.5,
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  borderBottom: `1px solid ${theme.palette.divider}`,
});
